<template>
  <div class="dialog_wrap" v-show="status">
    <div class="dialog" :style="{width:width,...style}" ref="showDoc">
      <div
        class="t_b-c dialog_title"
        @mousedown="mouseDownHandDoc($event)"
        @mouseup="mouseUpHandDoc($event)"
      >
        {{title}}
        <a href="javascript:;" class="dialog_close" @click="hide"></a>
      </div>
      <div class="dialog_content" :style="style">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wrap",
  props: {
    minHeight: {
      type: Boolean,
      default: false
    },
    minHeightValue: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "提示"
    },
    width: String
  },
  computed: {
    style() {
      const css = {};
      if (this.minHeightValue != 0) {
        css.minHeight = this.minHeightValue + "px";
      } else {
        if (!this.minHeight) css.minHeight = "500px";
        else css.minHeight = "auto";
      }

      return css;
    }
  },
  data() {
    return {
      status: false,
      moveDoc: {
        x: null,
        y: null
      }
    };
  },
  methods: {
    show() {
      this.status = true;
    },
    hide() {
      this.status = false;
      this.$emit("hide");
    },
    mouseDownHandDoc(event) {
      //显示文档的鼠标按下事件
      this.moveDoc.y = event.pageY - this.$refs.showDoc.offsetTop;
      this.moveDoc.x = event.pageX - this.$refs.showDoc.offsetLeft;
      event.currentTarget.style.cursor = "move";
      window.onmousemove = this.mouseMoveHandDoc;
      this.$refs.showDoc.setAttribute("flag", false);
      const firstTime = new Date().getTime();
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        const lastTime = new Date().getTime();
        if (lastTime - firstTime < 200) {
          this.$refs.showDoc.setAttribute("flag", true);
        }
      };
    },
    mouseMoveHandDoc(event) {
      let moveTop = event.pageY - this.moveDoc.y + "px";
      let moveLeft = event.pageX - this.moveDoc.x + "px";
      this.$refs.showDoc.style.top = moveTop;
      this.$refs.showDoc.style.left = moveLeft;
    },
    mouseUpHandDoc(event) {
      window.onmousemove = null;
      event.currentTarget.style.cursor = "move";
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';
@media screen and (max-width: 900px) { 
  .dialog_wrap .dialog {width: 80% !important;
    }
} 
.dialog_wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);

  .dialog {
    width: 1000px;
    background: #ffffff;
    position: absolute;
    left: 50%;
    top: 50%;
    min-width: 300px;
    min-height: 400px;
    transform: translateX(-50%) translateY(-50%);

    .dialog_title {
      font-size: 14px;
      height: 36px;
      line-height: 36px;
      color: #ffffff;
      padding: 0 10px;
      position: relative;

      &:before {
        content: '';
        margin-right: 10px;
        vertical-align: middle;
        position: relative;
        top: -2px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: solid 1px #ffffff;
        border-radius: 5px;
      }

      .dialog_close {
        content: '';
        position: absolute;
        right: 10px;
        top: 50%;
        width: 14px;
        height: 14px;
        margin-left: -7px;
        margin-top: -7px;
        background: url('./images/close.png');
      }
    }

    .dialog_content {
      padding: 5px;
      overflow: auto;
      min-height: 300px;
      max-height: 500px;
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/wrap.vue